import { connect } from "react-redux";
import get from "lodash/get";

import {
  setCreateControlPoint as onSetCreateControlPoint,
  clearCreatePontrolPoint as onClearCreateControlPoint,
} from "./../../actions/createContolPointActions";

const mapStateToProps = (state) => ({
  createControlPoint: get(state, ["createControlPoint", "createControlPoint"], null),
  featureKey: get(state, ["createControlPoint", "featureKey"], null)
});

const mapDispatchToProps = { onSetCreateControlPoint, onClearCreateControlPoint };

const withCreateControlPoints = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withCreateControlPoints };
